<template>
  <span :id="model?.system?.id">
    <SmartLinkItemComponent
      :id="model?.system?.id"
      class="content-block"
      :component="!model?.system?.workflow"
    >
      <div class="container">
        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
          <h2 class="content-block__title">
            {{ model?.elements.title.value }}
          </h2>
        </SmartLinkStandaloneElement>
        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
          <div class="content-block__content block-richtext">
            <template v-if="textAlignment == 'centered'">
              <template v-if="splitCharacterCount != 0">
                <RichText :value="undefined" :portable-text="portableText1" />
                <div :id="`collapse-${model?.system?.id}`" ref="showMore" class="collapse">
                  <RichText :value="undefined" :portable-text="portableText2" />
                </div>
              </template>
              <RichText v-else :value="model?.elements.content.value" />
            </template>
            <template v-else>
              <template v-if="splitCharacterCount != 0">
                <div class="row d-none d-lg-flex block-richtext">
                  <div class="col-lg-6 content-block__column1">
                    <RichText :value="undefined" :portable-text="portableText1" />
                  </div>
                  <div class="col-lg-6 content-block__column2">
                    <RichText :value="undefined" :portable-text="portableText2" />
                  </div>
                </div>
                <div class="d-lg-none block-richtext">
                  <RichText :value="model?.elements.content.value" />
                </div>
              </template>
              <div v-else class="block-richtext">
                <RichText :value="model?.elements.content.value" />
              </div>
            </template>
          </div>
        </SmartLinkStandaloneElement>

        <button
          v-if="splitCharacterCount != 0 && textAlignment == 'centered'"
          :id="`collapse-button-${model?.system?.id}`"
          class="btn btn-light px-0"
          type="button"
          aria-expanded="false"
          data-bs-toggle="collapse"
          :data-bs-target="`#collapse-${model?.system?.id}`"
          :aria-controls="`collapse-${model?.system?.id}`"
        >
          <template v-if="showMoreCollapsed">
            Show More
            <IconCaretDown height="20" />
          </template>
          <template v-else>
            Show Less
            <IconCaretUp height="20" />
          </template>
        </button>
      </div>
    </SmartLinkItemComponent>
  </span>
</template>
<script lang="ts" setup>
import { useEventListener } from '@vueuse/core'
import type { ContentBlockModel } from '~/models'
import { contentTypes } from '~/models'

const type = contentTypes.content_block
const props = defineProps<{ model: ContentBlockModel }>()

const splitCharacterCount = props.model?.elements.readMoreCharacterCount.value ?? 0
const { portableText1, portableText2 } = splitPortableText(
  splitCharacterCount,
  props.model?.elements.content.value
)

const { scrollToElementById } = useSmoothScroll()
const showMoreCollapsed = ref<boolean>(true)
const showMore = ref<HTMLElement | null>(null)
const initShowMore = () => {
  if (!showMore.value) return
  useEventListener(showMore.value, 'show.bs.collapse', () => {
    showMoreCollapsed.value = false
    const prev = showMore.value?.previousElementSibling as HTMLElement
    const firstChild = showMore.value?.firstElementChild as HTMLElement
    if (prev && firstChild && prev.tagName == 'UL' && firstChild.tagName == 'UL') {
      prev.style.marginBottom = '0px'
    }
  })
  useEventListener(showMore.value, 'hide.bs.collapse', () => {
    showMoreCollapsed.value = true
    ;(showMore.value?.previousElementSibling as HTMLElement).style.marginBottom = 'revert'
    scrollToElementById(props.model.system.id, 150, true)
  })
}

const textAlignment = computed(() => {
  const option = firstOrDefault(props.model?.elements.textAlignment.value)
  if (option) {
    // return two_column or centered
    return option.codename
  }
  return 'centered'
})

onMounted(() => {
  initShowMore()
})
</script>
